import { Pipe, PipeTransform } from '@angular/core';
import { PendingCommission } from '../models';

@Pipe({
    name: 'pendingCommissionViewFilter',
    standalone: false
})
export class PendingCommissionViewFilterPipe implements PipeTransform {
	transform(
		pendingCommissions: PendingCommission[],
		commissionViewFilterIndex: boolean,
		commissionViewFilterLayeredPurchasing: boolean,
	): PendingCommission[] {
		if (!pendingCommissions) {
			return [];
		}

		return pendingCommissions.filter(
			p => (commissionViewFilterIndex && !p.isPurchasingLayer) || (commissionViewFilterLayeredPurchasing && p.isPurchasingLayer),
		);
	}
}
